import { SMAR_ASSET_THUMBNAILS_COMPONENTS } from './common/asset-thumbnails/smar-asset-thumbnails-components';

export const SMAR_ATTACHMENT_SELECTOR_COMPONENTS = {
  ...SMAR_ASSET_THUMBNAILS_COMPONENTS,
};
